
import { Shield } from 'lucide-react';

export const TrustSection = () => {
  return (
    <section className="py-12 bg-white border-t border-gray-200">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center">
          <Shield size={28} className="mx-auto mb-4 text-emergency-600" />
          <h3 className="text-xl font-bold mb-3">Your Security Is Our Priority</h3>
          <p className="text-muted-foreground mb-6">
            All your personal information and uploaded images are protected with enterprise-grade security. 
            We never share your data with third parties without your explicit consent.
          </p>
          <div className="flex justify-center space-x-6">
            <div className="text-center">
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="mx-auto mb-2 text-emergency-600">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <span className="text-sm font-medium">End-to-End Encryption</span>
            </div>
            <div className="text-center">
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="mx-auto mb-2 text-emergency-600">
                <rect x="3" y="11" width="18" height="11" rx="2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M7 11V7a5 5 0 0110 0v4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <span className="text-sm font-medium">Data Protection</span>
            </div>
            <div className="text-center">
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="mx-auto mb-2 text-emergency-600">
                <path d="M22 12h-4l-3 9L9 3l-3 9H2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <span className="text-sm font-medium">24/7 Monitoring</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
